import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { COUNTRY, COUNTRY_ALL, COUNTRY_CREATE, COUNTRY_LIST, GLOBAL_STATE } from '../constants/actionTypes'

const calendarSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const countrySelector = createSelector(calendarSelector, data => data[COUNTRY])

export const countryListSelector = createSelector(calendarSelector, data => data[COUNTRY_LIST])

export const countryAllSelector = createSelector(calendarSelector, data => data[COUNTRY_ALL])

export const countryCreateSelector = createSelector(calendarSelector, data => data[COUNTRY_CREATE])

export const countryAllOptionsSelector = createSelector(countryAllSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({ label: item.title || '', value: item.id }))
      : [],
  }
})
